import cn from 'clsx'

import { getValueWithCurrency } from "@App/helpers/toCurrency";
import { getValueWithPercentage } from "@App/helpers/toPercentage";
import { Checkbox } from '@App/ui/crypto_exchange/desktop/components/controls/Checkbox'

import { BalanceOption } from '../..'

import s from './BalanceSettings.module.scss'

export const BalanceSettings = ({
  options,
  setOptionStatus,
  currencyCode
}: {
  options: BalanceOption[]
  setOptionStatus: (option: string, status: boolean) => void
  currencyCode: string
}) => {
  const handleCheckBoxClick = (option: string, status: boolean) => {
    setOptionStatus(option, status)
  }

  return (
    <div className={s.container}>
      {options.map((option) => (
        <div key={option.name} className={s.option} onClick={() => handleCheckBoxClick(option.name, !option.isActive)}>
          <div className={s.info}>
            <span className={s.name}>{option.name}</span>
            <span className={cn(s.value, option.highlightValue && s.highlight)}>
                {option.type === 'currency' ? getValueWithCurrency(currencyCode, option.value) : getValueWithPercentage(option.value)}
            </span>
          </div>
          <div className={s.action}>
            <Checkbox
              name="isActive"
              checked={option.isActive}
              label={''}
              onChange={(val) => handleCheckBoxClick(option.name, val)}
            />
          </div>
        </div>
      ))}
    </div>
  )
}
